module.exports = __webpack_public_path__ + "img/teva_slogan.506a9333.svg";